<template>
    <div>
        <v-data-table
                :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50, 100]}"
                :headers="headers"
                :items="items"
                :items-per-page="50"
                :loading="loading"
                :options.sync="options"
                :server-items-length="totalItems"
        >
            <template v-slot:item.forDate="{ item }">
                {{item.forDate | moment('DD/MM/YYYY')}}
            </template>
            <template v-slot:item.computingDateTime="{ item }">
                {{item.computingDateTime | moment('DD/MM/YYYY HH:mm:ss')}}
            </template>
            <template v-slot:item.firstFetchingDateTime="{ item }">
                <span v-if="item.firstFetchingDateTime">{{item.firstFetchingDateTime | moment('YYYY/MM/DD HH:mm:ss')}}</span>
                <span v-else>Jamais téléchargé</span>
            </template>
            <template v-slot:item.exportState="{ item }">
                {{item.exportState | stateToText}}
            </template>
            <template v-slot:item.download="{ item }">
                <v-btn :loading="item.loading" @click="download(item)" class="elevation-2"
                       color="blue" icon small
                       v-if="isDownloadable(item)">
                    <v-icon>cloud_download</v-icon>
                </v-btn>
            </template>

        </v-data-table>
        <v-snackbar :bottom="true" :timeout="0" color="error" v-model="error">
            Une erreur est survenue. Veuillez réessayer, ou contacter l'équipe de support de Yodatech
            <v-btn @click="fetch" dark text>Réessayer</v-btn>
        </v-snackbar>
        <v-snackbar :bottom="true" :timeout="5000" color="error" v-model="downloadError">
            Une erreur est survenue. Veuillez réessayer, ou contacter l'équipe de support de Yodatech
            <v-btn @click="downloadError = false" dark text>Fermer</v-btn>
        </v-snackbar>
    </div>
</template>

<script>
	export default {
		name: "ReportTable",
		data() {
			return {
				headers: [
					{text: "Date", value: "forDate", sortable: true},
					{text: "Date de génération", value: "computingDateTime", sortable: true},
					{text: "État", value: "exportState", sortable: true},
					{text: "Date de premier téléchargement", value: "firstFetchingDateTime", sortable: true},
					{text: "", value: "download", sortable: false}
				],
				items: [],
				loading: false,
				options: {},
				totalItems: 0,
				error: false,
				downloadError: false
			}
		},
		filters: {
			stateToText(state) {
				switch (state) {
					case "SUCCESS_NEVER_FETCHED":
					case "SUCCESSFULLY_FETCHED":
						return "Généré avec succès";
					case "COMPUTING":
						return "En cours de génération...";
					case "WRITING_ON_DISK_FAILED":
						return "Erreur lors de l'écriture sur le disque";
					case "COMPUTING_FAILED":
						return "Erreur du calcul de l'export";
					default:
						return state;
				}
			}
		},
		watch: {
			options: {
				handler() {
					this.fetch();
				},
				deep: true,
			},
		},
		mounted() {
			this.fetch();
		},
		methods: {
			fetch() {
				this.loading = true;
				this.error = false;
				const {sortBy, sortDesc, page, itemsPerPage} = this.options;
				let url = this.$config.apiUrl + "/reports?page=" + (page - 1) + "&size=" + itemsPerPage;
				if (sortBy.length) {
					url += "&sort=" + sortBy[0] + "," + (sortDesc[0] ? 'desc' : 'asc');
				}
				this.$http.get(url)
					.then(r => {
						this.items = r.data.content;
						this.totalItems = r.data.totalElements;
					})
					.catch((e) => this.error = true)
					.finally(() => this.loading = false)
			},
			isDownloadable(item) {
				return item.exportState === "SUCCESS_NEVER_FETCHED" || item.exportState === "SUCCESSFULLY_FETCHED";
			},
			download(item) {
				item.loading = true;
				this.downloadError = false;
				this.$http({
					url: this.$config.apiUrl + "/reports/id/" + item.id,
					method: 'GET',
					headers: {'Accept': 'text/csv'},
					responseType: 'blob', // important
				})
					.then((response) => {
						// Downloading the file
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', 'report-' + item.forDate + '.csv');
						document.body.appendChild(link);
						link.click();

						// Refresh the table
						this.fetch();
					})
					.catch(e => this.downloadError = true)
					.finally(() => item.loading = false);
			}
		}
	}
</script>

<style scoped>

</style>
